import { Component } from '@angular/core';

import { FirebaseService } from '../../services/firebase.service';

@Component({
	selector    : 'menu',
	templateUrl : 'menu.html',
	styleUrls   : [ 'menu.scss' ]
})

export class MenuComponent {
  admin       : boolean = false;
  email       : string;
  uid         : string;
  displayName : string;

	constructor(
    private firebaseService : FirebaseService
  ) {
    this.initUser();
  }

  initUser(counter : number = 0) : void {
    if (this.firebaseService.user) {
      this.firebaseService.user
        .subscribe(user => {
          this.admin       = !!user.admin;
          this.email       = user.email;
          this.uid         = user.$key;
          this.displayName = user.displayName || null;
        });
    } else if (counter++ < 100) {
      setTimeout(() => this.initUser(counter), 10);
    }
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-dev/src/app/components/menu/menu.ts